var _ellipse, _ellipse2, _path, _path2, _path3, _path4, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 59,
    viewBox: "0 0 58 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.8525,
    cy: 29.4642,
    rx: 28.5939,
    ry: 28.7562,
    fill: "#C7C7C7",
    fillOpacity: 0.25
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.8525,
    cy: 29.4637,
    rx: 18.5766,
    ry: 18.682,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0427 22.6543C21.6307 23.0664 21.6307 23.7344 22.0427 24.1465C22.4548 24.5585 23.1228 24.5585 23.5349 24.1465C23.9469 23.7344 23.9469 23.0664 23.5349 22.6543C23.1228 22.2423 22.4548 22.2423 22.0427 22.6543ZM34.1703 34.7818C33.7582 35.1939 33.7582 35.862 34.1703 36.274C34.5823 36.686 35.2504 36.686 35.6624 36.274C36.0745 35.862 36.0745 35.1939 35.6624 34.7818C35.2504 34.3698 34.5823 34.3698 34.1703 34.7818ZM22.6489 23.5403L34.7765 35.6678L35.0562 35.388L22.9287 23.2605L22.6489 23.5403Z",
    fill: "#0072DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0427 36.2734C22.4548 36.6855 23.1228 36.6855 23.5349 36.2734C23.9469 35.8614 23.9469 35.1933 23.5349 34.7813C23.1228 34.3692 22.4548 34.3692 22.0427 34.7813C21.6307 35.1933 21.6307 35.8614 22.0427 36.2734ZM34.1703 24.1459C34.5823 24.5579 35.2504 24.5579 35.6624 24.1459C36.0745 23.7338 36.0745 23.0658 35.6624 22.6537C35.2504 22.2417 34.5823 22.2417 34.1703 22.6537C33.7582 23.0658 33.7582 23.7338 34.1703 24.1459ZM22.9287 35.6672L35.0562 23.5397L34.7765 23.2599L22.6489 35.3875L22.9287 35.6672Z",
    fill: "#0072DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8425 42.1242C29.8151 42.1242 30.6035 41.3358 30.6035 40.3633C30.6035 39.3907 29.8151 38.6023 28.8425 38.6023C27.87 38.6023 27.0816 39.3907 27.0816 40.3633C27.0816 41.3358 27.87 42.1242 28.8425 42.1242ZM28.8425 20.3254C29.8151 20.3254 30.6035 19.537 30.6035 18.5644C30.6035 17.5919 29.8151 16.8035 28.8425 16.8035C27.87 16.8035 27.0816 17.5919 27.0816 18.5644C27.0816 19.537 27.87 20.3254 28.8425 20.3254ZM29.1727 40.3633L29.1727 18.5644L28.5123 18.5644L28.5124 40.3633L29.1727 40.3633Z",
    fill: "#0072DD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1812 29.4639C16.1812 30.4364 16.9696 31.2248 17.9421 31.2248C18.9147 31.2248 19.7031 30.4364 19.7031 29.4639C19.7031 28.4913 18.9147 27.7029 17.9421 27.7029C16.9696 27.7029 16.1812 28.4913 16.1812 29.4639ZM37.98 29.4639C37.98 30.4364 38.7684 31.2248 39.741 31.2248C40.7135 31.2248 41.5019 30.4364 41.5019 29.4639C41.5019 28.4913 40.7135 27.7029 39.741 27.7029C38.7684 27.7029 37.98 28.4913 37.98 29.4639ZM17.9421 29.794H39.741V29.1337H17.9421V29.794Z",
    fill: "#0072DD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.8516,
    cy: 29.4644,
    r: 2.6244,
    transform: "rotate(-45 28.8516 29.4644)",
    fill: "#0072DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionIcon);
export default __webpack_public_path__ + "static/media/connection-icon.2988acb4e533dc3551a2ec3ec1a04434.svg";
export { ForwardRef as ReactComponent };